import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$lang/blogs")({
  component: React.lazy(() => import("@/pages/blogs").then((mod) => ({ default: mod.default }))),
});
